<template>
  <header class="audits-header">
    <div class="audits-header-filters">
      <DateRangeFilter data-entity="audit" />
      <OperationsFilter data-entity="audit" />
      <LoginIdsFilter />
    </div>

    <div class="search-wrapper">
      <app-search @submit="search" />
    </div>
  </header>
</template>

<script>
    import LoginIdsFilter from '@components/filters/LoginIdsFilter'
    import DateRangeFilter from '@components/filters/DateRangeFilter'
    import OperationsFilter from '@components/filters/OperationsFilter'
    import AppSearch from '@components/Search'

    export default {
        components: {
            DateRangeFilter,
            AppSearch,
            OperationsFilter,
            LoginIdsFilter
        },

        data() {
            return {
              operations: undefined
            }
        },

        computed: {
        },

        async mounted(){
          this.$store.commit('AUDIT_RESET_FILTERS');
        },

        methods: {
            search(search) {
              this.$store.commit('AUDIT_SET_FILTER', { key: 'query', value: search })
            }
        },
    }
</script>

<style lang="scss" scoped>
.audits-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .audits-header-filters {
    display: flex;

    > * {
      margin-right: 20px;
    }
  }
}
</style>
